export default function BusinessAccountSettings() {
    return (
        <div>
            business account settings
        </div>
    );
};